<template>
  <div class="building-handover-templates">
    <TMSHeader
      :buttons="enableButtons"
      title="Handover Templates"
    />
    <div class="template-list">
      <table>
        <thead>
          <tr>
            <th class="template-name">{{ $t('settings.template.templateName') }}</th>
            <th class="template-updated-by">{{ $t('handover.lastUpdateOnandBy') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(temp, index) in templateList"
            :key="index"
          >
            <td
              class="template-name"
              @click="gotoEditTemplatePage(temp.id)"
            ><a>{{ temp.title }}</a></td>
            <td class="template-updated-by">
              <span>{{ temp.updator.displayName + ' ' + formatDate(temp.updatedAt) }}</span>
              <i
                class="operate fa-times fa"
                @click="openModal(temp, index)"
                v-if="templateList.length > 1 && isDeleteBtnShow"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Modal
      ref="confirm-delete-template-modal"
      class="confirm-delete-template-modal"
      :modalId="`delete-template-${+new Date()}`"
    >
      <p
        slot="modal-header"
        class="font-bold"
      >{{ $t('settings.template.deleteHint') }}</p>
      <div slot="btns">
        <button
          class="btn--orange"
          @click="closeModal"
        >{{ $t('action.cancel') }}</button>
        <button
          class="btn--darkblue"
          @click="delOneTemplate"
        >{{ $t('action.ok') }}</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getBuildingInfoById, delOneTemplateFromBuilding } from '@/api/buildings/request'
import TMSHeader from '@/controls/TMSHeader'
import dateUtil from '@/utils/dateUtil'
import Modal from '@/controls/Modal'
import { aclHelper } from '@/utils/aclHelper'

export default {
  name: 'BuildingHandoverTemplates',
  components: {
    TMSHeader,
    Modal,
  },
  data () {
    return {
      buildingInfo: [],
      buildingId: '',
      buttons: [{
        title: 'New Template',
        cls: 'btn--orange',
        func: this.gotoEditTemplatePage,
        show: aclHelper.getSettingsUpdateAccess(),
      }],
      templateList: [],
      deleteIndex: -1,
      deleteItem: '',
    }
  },
  computed: {
    isDeleteBtnShow () {
      return aclHelper.getSettingsUpdateAccess()
    },
    enableButtons () {
      return this.buttons.filter((button) => {
        return button.show
      })
    },
  },
  methods: {
    navBack () {
      this.$router.goBack()
    },
    gotoEditTemplatePage (tid = 'createTemplate') {
      this.$router.push({
        name: 'building-detail',
        params: {
          id: this.buildingId,
          tid: tid,
        },
      })
    },
    formatDate (item) {
      return dateUtil.formatDate(item, true)
    },
    async delOneTemplate () {
      await delOneTemplateFromBuilding(this.buildingId, this.deleteItem.id)
      this.templateList.splice(this.deleteIndex, 1)
      this.closeModal()
    },
    openModal (item, index) {
      this.deleteIndex = index
      this.deleteItem = item
      this.$refs['confirm-delete-template-modal'].open()
    },
    closeModal () {
      this.$refs['confirm-delete-template-modal'].close()
    },
  },
  async mounted () {
    this.buildingId = this.$router.currentRoute.params.id
    this.buildingInfo = await getBuildingInfoById(this.buildingId)
    this.templateList = this.buildingInfo.templates
  },
}
</script>

<style lang='scss'>
.building-handover-templates {
  .tms-header-top, .content, .template-list {
    max-width: 1440px;
    margin: 0 auto;
  }
  .tms-header {
    min-height: 100px;
  }
  .tms-header__box .content{
    display: flex;
    .main-title {
      flex: 1;
    }
  }
  .tms-header__box {
    .main-title {
      height: 40px;
      line-height: 40px;
      span {
        font-size: 20px ;
      }
    }
  }
  .template-name {
    width: 70%;
  }
  .template-updated-by {
    width: 30%;
  }
  .template-list {
    margin-top: 20px;
    margin-bottom: 20px;
    box-shadow: 0 0 2px 0 rgba(172, 172, 172, 0.5);
    table {
      border: 1px solid #ededed;
    }
    th {
      text-transform: uppercase;
      color: #0C3A58;
    }
    overflow: auto;
    height: calc(100vh - 241px);
    padding: 20px;
    .operate {
      float: right;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
